import Input from '../../../Input/Input';
import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { object } from 'yup';
import { stringScheme } from 'src/utils/validation-schemes';

export const IntegrationZendeskEmailAutoSetup = ({ integration, onSubmit }) => {
  const { handleSubmit, control } = useForm({
    defaultValues: {
      escalated_assignee_id: '',
      escalated_custom_status_id: '',
    },
    resolver: yupResolver(
      object({
        escalated_assignee_id: stringScheme({ required: false }).label('Escalated assignee id'),
        escalated_custom_status_id: stringScheme({ required: false }).label(
          'Escalated custom status id',
        ),
      }),
    ),
  });

  const submit = (data) => {
    onSubmit({
      integrationId: integration.id,
      escalated_assignee_id: data.escalated_assignee_id,
      escalated_custom_status_id: data.escalated_custom_status_id,
    });
  };

  return (
    <form id="auto-setup-form" onSubmit={handleSubmit(submit)}>
      <div className="content">
        <Controller
          control={control}
          name="escalated_assignee_id"
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Input
              type={'text'}
              label={'Escalated assignee id'}
              placeholder={''}
              invalidMessage={error?.message}
              value={value}
              isValid={!error?.message}
              onChange={onChange}
            />
          )}
        />
      </div>
      <div className="content">
        <Controller
          control={control}
          name="escalated_custom_status_id"
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Input
              type={'text'}
              label={'Escalated custom status id'}
              placeholder={''}
              invalidMessage={error?.message}
              value={value}
              isValid={!error?.message}
              onChange={onChange}
            />
          )}
        />
      </div>
    </form>
  );
};
